import React, { useEffect, useState } from "react";
import { venues } from "../mock/venues";

/** Sticky right-hand marker naming the venue currently being read. */
const StickyVenueBadge = () => {
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    const onScroll = () => {
      let found = null;
      venues.forEach((v) => {
        const el = document.getElementById(v.slug);
        if (!el) return;
        const box = el.getBoundingClientRect();
        if (box.top <= 170 && box.bottom > 170) found = v;
      });
      setCurrent(found);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToVenue = () => {
    if (!current) return;
    document.getElementById(current.slug).scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <button
      onClick={scrollToVenue}
      data-testid="sticky-venue-badge"
      aria-hidden={!current}
      tabIndex={current ? 0 : -1}
      className={`fixed right-0 top-1/2 z-40 hidden -translate-y-1/2 items-center rounded-l-lg border border-r-0 py-3 pl-3.5 pr-3 text-left shadow-md transition-all duration-300 lg:flex ${
        current
          ? `${current.theme.bg} ${current.theme.rule} translate-x-0 opacity-100`
          : "translate-x-full opacity-0"
      }`}
      style={{ pointerEvents: current ? "auto" : "none" }}
    >
      <span className="block w-[110px]">
        <span className="block text-[0.5rem] uppercase tracking-[0.16em] text-muted-foreground">
          Reading
        </span>
        <span
          data-testid="sticky-venue-name"
          className={`mt-0.5 block font-serif text-[0.8rem] leading-tight ${current ? current.theme.accent : ""}`}
        >
          {current ? current.name : ""}
        </span>
        <span className="mt-0.5 block text-[0.62rem] text-muted-foreground">
          {current ? current.contact.phone : ""}
        </span>
      </span>
    </button>
  );
};

export default StickyVenueBadge;
